import { fromPromise } from 'xstate';
import { apolloClient } from '@/lib/apollo';
import { RegisterFilingCredentialMutation } from '@/lib/gql/__generated__/canonical-documents';
import type {
  RegisterFilingCredentialInput,
  RegisterFilingCredentialMutationMutation,
} from '@/lib/gql/__generated__/graphql';

export const registerFilingCredentialActor = fromPromise<
  RegisterFilingCredentialMutationMutation,
  RegisterFilingCredentialInput
>(async ({ input }) => {
  const result = await apolloClient.mutate({
    mutation: RegisterFilingCredentialMutation,
    variables: {
      input: {
        filingCredentialId: input.filingCredentialId,
        environment: input.environment,
        transmitterId: input.transmitterId,
      },
    },
  });
  const data = result.data;
  const response = data?.registerFilingCredential;
  if (!data || !response?.success)
    throw new Error(response?.error?.message ?? 'Filing credential could not be registered.');
  return data;
});
